// Visual styling for generations and members. Best-effort signature colors
// per the design handoff (verify against StelLive brand before shipping).

import type { GenerationSlug, MemberStyle, Generation } from '../types.ts';

export const GENERATIONS: Generation[] = [
  { id: 'everys',   ko: '에버리스', en: 'Everys',    tint: '#F4EFFA', accent: '#6B3D8C' },
  { id: 'universe', ko: '유니버스', en: 'Universe',  tint: '#EEF7F1', accent: '#3FA46A' },
  { id: 'cliche',   ko: '클리셰',   en: 'Cliche',    tint: '#FFF5EB', accent: '#E78A2D' },
];

export const GENERATION_BY_ID: Record<GenerationSlug, Generation> = Object.fromEntries(
  GENERATIONS.map((g) => [g.id, g]),
) as Record<GenerationSlug, Generation>;

// Member signature colors sourced from the StelLive namu wiki member infoboxes
// (https://namu.wiki/w/스텔라이브). Kangji has no member-color cell on that
// page (she's 0기 / pre-StelLive), so we keep a brand-adjacent red for her.
export const MEMBER_STYLES: Record<string, MemberStyle> = {
  yuni:    { color: '#857FD8', soft: '#EBE9FA', initial: '유' },
  huya:    { color: '#8166A1', soft: '#EBE3F1', initial: '후' },
  mashiro: { color: '#25282A', soft: '#DDDEDF', initial: '마' },
  lize:    { color: '#971B2F', soft: '#F5DBE0', initial: '리' },
  tabi:    { color: '#9ADAFF', soft: '#E5F4FF', initial: '타' },
  hina:    { color: '#F2DCBF', soft: '#FCF6EE', initial: '히' },
  rin:     { color: '#2B66C0', soft: '#DCE4F4', initial: '린' },
  shibuki: { color: '#C2AFE6', soft: '#F1ECFA', initial: '시' },
  nana:    { color: '#DF7685', soft: '#FBE2E6', initial: '나' },
  riko:    { color: '#A6D0A6', soft: '#ECF5EC', initial: '리' },
};

export const FALLBACK_STYLE: MemberStyle = {
  color: '#8A847C',
  soft: '#F2EEE6',
  initial: '?',
};
